<span [class]="'badge ' + fromSize(size) + ' ' + fromVisibility(visibility)"
    [class._pulse]="pulse">
    <ng-content></ng-content>
</span>
